import { render, staticRenderFns } from "./OrderViewer.vue?vue&type=template&id=6e421a91&scoped=true"
import script from "./OrderViewer.vue?vue&type=script&lang=js"
export * from "./OrderViewer.vue?vue&type=script&lang=js"
import style0 from "./OrderViewer.vue?vue&type=style&index=0&id=6e421a91&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e421a91",
  null
  
)

export default component.exports